import { Helmet } from "react-helmet"
import LayoutDashboard from './../../../components/layouts/layout_dashboard';
import CustomHeader from './../../../components/customs/header';
import { Link } from 'react-router-dom';
import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { getRequestUpdate } from "../../../services/finance/request_update_service";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import InputSearch from "../../../components/form/input_search";

const Approved = () => {
    const [accessToken, setAccessToken] = useState("")
    const navigate = useNavigate()
    const [loading, setloading] = useState(false)

    const [keyword, setKeyword] = useState("")
    const [data, setData] = useState([])
    const [category, setCategory] = useState('semua')
    const [currentPage, setCurrentPage] = useState(1)

    const fetchData = async (accessToken, currentPage) => {
        setloading(true)
        try {
            const params = {
                keyword: keyword,
                category: category,
                current_page : currentPage
            }
            const response = await getRequestUpdate(accessToken, params)
            if (response.status === 200) {
                setData(response.data.data)
            } else {

            }
        } catch (error) {

        }
        setloading(false)
    }

    useEffect(() => {
        const accessToken = localStorage.getItem('access_token-terra_app')
        if (accessToken) {
            setAccessToken(accessToken)
            fetchData(accessToken, currentPage)
        }
    }, [])

    return (
        <>
            <Helmet>
                <title>Persetujuan Update</title>
            </Helmet>
            <LayoutDashboard>
                <CustomHeader>
                    <p>Persetujuan Update</p>
                </CustomHeader>
                <div>
                    
                </div>
            </LayoutDashboard>
        </>
    )
}

export default Approved